import React, {Component} from "react";
import Tree from "rc-tree";
import {BsyUtils} from "../../utils/Utils";

class SelectTree extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedKeys: [],
      treeData: [],
    }
  }

  deepCopy = (obj, visited = new WeakMap()) => {
    // 如果 obj 是 null 或不是对象，直接返回它自身
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    // 如果 obj 已经被访问过，返回它的副本以避免循环引用
    if (visited.has(obj)) {
      return visited.get(obj);
    }

    // 根据 obj 的类型创建一个新的空对象或数组
    let copy;
    if (Array.isArray(obj)) {
      copy = [];
    } else {
      copy = Object.create(Object.getPrototypeOf(obj));
    }

    // 记录访问过的 obj，以便处理循环引用
    visited.set(obj, copy);

    // 遍历 obj 的属性或数组元素并进行递归深拷贝
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        copy[key] = this.deepCopy(obj[key], visited);
      }
    }

    return copy;
  }

  componentDidMount() {
    const t = this.props.selectContext;
    const { items, value } = t.state;
    let role = {};
    if (items.length > 0) {
      items.map(res1 => {
        if (res1.role_id === value) {
          role = res1
        }
      })
    }
    let expandedKeys = [];
    const getExpandedKeys = (targetId) => {
      items.map(res1 => {
        if (res1.role_id === targetId) {
          expandedKeys.push(res1.role_id);
          res1.parent !== "0" && getExpandedKeys(res1.parent);
        }
      })
    }
    role.parent && getExpandedKeys(role.parent)
    let newChild = this.transformToTreeFormat(this.deepCopy(items));
    let child = [];
    let levelChild = 0;
    let treeData = newChild.map(res =>{
      return this.createTreeMenuData(res, levelChild, child)
    })

    this.setState({treeData: treeData, expandedKeys})
  }

  transformToTreeFormat = (b) => {
    let simpleData = {
      enable: true,
      idKey: "role_id",
      pIdKey: "parent"
    }
    var c, d, e = simpleData.idKey, f = simpleData.pIdKey, g = 'child';
    if (!e || "" == e || !b)
      return [];
    if (Array.isArray(b)) {
      var h = []
        , i = [];
      for (c = 0, d = b.length; c < d; c++) {
        i[b[c][e]] = b[c];
      }

      for (c = 0, d = b.length; c < d; c++) {

        if (i[b[c][f]] && b[c][e] != b[c][f]) {
          i[b[c][f]][g] || (i[b[c][f]][g] = [])


          b[c].title = b[c].name;
          b[c].key = b[c][simpleData.idKey];
          i[b[c][f]][g].push(b[c])
        } else {
          b[c].title = b[c].name;
          b[c].key = b[c][simpleData.idKey];
          h.push(b[c])
        }

      }
      return h
    }
    b.title = b.name;
    b.key = b[simpleData.idKey];
    return [b]
  }

  createTreeMenuData = (data, levelChild, child) => {
    let newData = {};

    BsyUtils.forEach(data, (key, val) => {
      if (key === "icon") {
        return
      }
      newData[key] = val;
    })
    newData.isLeaf = false;
    // newData.title = <></>;
    if (newData.type === "1") {
      newData.levelChild = levelChild;
      newData.parentId = data.parent;
      newData.key = data.role_id;
      // newData.title = entryMap[data.id || data.entryId].name;
      newData.children = [];
      if (data.child && data.child.length > 0) {
        levelChild++;
        let newChlid = data.child.filter((string) => {
          return string
        })
        newData.children = newChlid.map(res => {
          return this.createTreeMenuData(res, levelChild, child)
        })
      }

    } else {
      newData.levelChild = levelChild;
      newData.key = data.role_id;
      // newData.title = entryMap[data.id || data.entryId].name;
      newData.parentId = data.parent;
    }
    return newData;
  }

  render() {
    const t = this.props.selectContext;
    const { textField, valueField, colorEnable, dataOther, dataOtherPos, selectOther, subform } = t.options;
    const { items, value, seaching, isMore } = t.state;
    const {expandedKeys, treeData} = this.state;

    return <Tree
      treeData={treeData}
      isVirtualized={false}
      defaultExpandedKeys={[1]}
      expandedKeys={[...new Set(expandedKeys)]}
      selectedKeys={[value]}
      onClick={(e, node)=>{
        t.selectItem(node);
      }}
      onExpand={(expanded, node) => {
        if(!node.expanded){
          const expandChild = (node) => {
            node.map(res=>{
              let i = expandedKeys.indexOf(res.role_id);
              if(i > -1){
                expandedKeys.splice(expandedKeys.indexOf(res.role_id), 1);
              }
              res.children && expandChild(res.children)
            })
          }
          expandedKeys.splice(expandedKeys.indexOf(node.node.role_id), 1);
          node.node.children && expandChild(node.node.children)
          this.setState({expandedKeys: expandedKeys})
        }else{
          this.setState({expandedKeys: expanded})
        }
      }}
      onDragEnter={(node) => {
        this.setState({expandedKeys: node.expandedKeys})
      }}
      draggable={false}
      icon={(rowInfo) => {
        return <>
          <i className={`node-icon ${rowInfo.data.type === "0" ? "icon-role" : "icon-role-group"}`} id={rowInfo.data._id}/>
        </>
      }}
      switcherIcon={(rowInfo) => {
        return <>
          {<i className={rowInfo.expanded ? 'icon-tree-collapse' : 'icon-tree-expand'} style={{visibility: (rowInfo.data.children && rowInfo.data.children.length > 0) ? "" : "hidden"}}></i>}
        </>
      }}
    />
  }
}

export default SelectTree;